import { useIntl } from "react-intl";

import PresenceActiveIcon from "@atlaskit/icon/glyph/presence-active";

import Link from "@/components/wpl/link/src";
import { useLocalizedHref } from "@/libraries/web-framework";

import { tabbedHeroSectionSpacesMessages } from "../messages/tabbed-hero-section.messages";

import { ContentTypeVideo } from "./content-type-video";

export const SpacesContentType = () => {
    const intl = useIntl();
    const ctaLink = useLocalizedHref(
        "/software/confluence/use-cases/knowledge-management-software"
    );

    return (
        <ContentTypeVideo
            title={intl.formatMessage(
                tabbedHeroSectionSpacesMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionSpacesMessages.contentDescription
            )}
            iconTitle={intl.formatMessage(
                tabbedHeroSectionSpacesMessages.contentIconTitle
            )}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionSpacesMessages.contentFeaturePoint1
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionSpacesMessages.contentFeaturePoint2
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionSpacesMessages.contentFeaturePoint3
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                }
            ]}
            cta={
                <Link
                    href={ctaLink}
                    text={intl.formatMessage(
                        tabbedHeroSectionSpacesMessages.contentCta
                    )}
                    type={"basic"}
                    doesArrowAnimate={true}
                    dataEventProps={{
                        "data-product-key": "confluence",
                        "data-event-component": "linkButton",
                        "data-event-container": "contentTypesSection",
                        "data-event": "clicked",
                        "data-label": "explore-knowledge-sharing",
                        "data-label-english": "Explore knowledge sharing",
                        "data-track-event":
                            "confluence-pt.content-types.spaces.cta"
                    }}
                />
            }
            reverseLayout
            videoSrc="https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Spaces_LowBR.webm"
            videoPreviewSrc="https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Spaces_Preview.webp"
        />
    );
};
